import { combineReducers } from 'redux';
import { userSlice } from '~/pages/UserSaga/User/userSlice';
import { userInventorySlice } from '~/pages/UserSaga/UserInventory/userInventorySlice';
import { userGoogleBillingSlice } from '~/pages/UserSaga/UserGoogleBilling/userGoogleBillingSlice';

export const userReducers = combineReducers({
    user: userSlice.reducer,
    userInventory: userInventorySlice.reducer,
    userGoogleBilling: userGoogleBillingSlice.reducer,
});
